export default {
      id: "ic_filter_mbs1-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_mbs1-usage",
      toString: function () {
        return this.url;
      }
    }